<template>
  <v-dialog :value="modal" @change="cancel" width="500" lazy persistent>
    <v-card v-if="modal">
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ titleAction }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="cancel()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout wrap row>
          <v-flex xs12 px-2>
            <translation-field
              v-model="option.name"
              :label="$t('name')"
              ref="name"
              required
            />
          </v-flex>
          <v-flex xs6 px-2>
            <v-text-field
              v-model="option.value"
              :label="$t('value')"
              type="number"
              :data-vv-name="$t('value')"
              :error-messages="errors.collect($t('value'))"
              v-validate="'required'"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn small @click="submit" color="success">
          {{ $t('accept') }}
        </v-btn>

        <v-btn small @click="cancel" color="primary">
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import TranslationField from '@/components/widgets/Input/TranslationField'

export default {
  name: 'OptionModal',
  components: { TranslationField },
  props: {
    modal: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      option: {}
    }
  },

  watch: {
    modal(val) {
      if (!val) this.cancel()
    },
    item: {
      handler: function(val) {
        if (val) this.option = { ...val }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    titleAction() {
      return this.item._id || this.item.key
        ? this.$t('updateModel', { field: this.$tc('option') })
        : this.$t('newAModel', { field: this.$tc('option') })
    }
  },
  methods: {
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(valid => {
        if (valid.some(valid => !valid)) return
        const payload = { ...this.option }
        if (!payload.key) payload.key = Date.now()
        this.$emit('add', payload)
        this.cancel()
      })
    },
    clear() {
      this.option = {}
    },
    cancel() {
      this.clear()
      this.$emit('close')
    }
  }
}
</script>
